<template>
  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="6"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ promotion.name }}
            </h1>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        class="content-header-right text-md-right d-md-block d-none mb-1"
        md="6"
        cols="12"
      >
        <b-button
          v-if="canViewThisAction('update', 'Promotion')"
          variant="flat-primary"
          :to="{ name: 'products-promotions-edit', params: { id: $route.params.id } }"
        >
          <feather-icon
            icon="EditIcon"
            class="mr-50"
            size="16"
          />
          <span class="align-middle">Edit</span>
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-card
          header="Promotions and Discount Details"
          header-tag="header"
        >
          <template #header>
            <b-button
              type="button"
              variant="flat-primary"
              class="primary-button-with-background mr-3"
            >
              <feather-icon
                icon="GridIcon"
                class=""
                size="20"
              />
            </b-button>
            <h3 class="align-middle mr-auto">
              Promotions and Discount Details
            </h3>
          </template>
          <b-table-simple
            borderless
            responsive
            class="custom-th-width"
          >
            <b-tbody>
              <b-tr>
                <b-th width="230">
                  Label for Agent/Customer
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.label || '-' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Type of Promotion
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.type || '-' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Coupon Code
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.couponCode || '-' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Total Quota
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.totalQuota != null ? promotion.totalQuota : 'No limit' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Quota per Agent
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.quotaPerAgent != null ? promotion.quotaPerAgent : 'No limit' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Applicable Agent(s)
                </b-th>
                <b-td class="mt-50">
                  {{ applicableAgentsText }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Validity - Start Date
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.validityStartDate ? dateFormat(promotion.validityStartDate) : '-' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Validity - End Date
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.validityEndDate ? dateFormat(promotion.validityEndDate) : '-' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Priority
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.priority != null ? promotion.priority : '-' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Applicable Suite(s)
                </b-th>
                <b-td class="mt-50">
                  {{ applicableSuitesText }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Applicable Products
                </b-th>
                <b-td class="mt-50">
                  {{ applicableProductsText }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Applicable Purchase Option(s)
                </b-th>
                <b-td class="mt-50">
                  {{ applicablePurchaseOptionsText }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Status
                </b-th>
                <b-td class="mt-50">
                  <b-badge
                    :variant="`light-${resolveStatusVariant(promotion.status)}`"
                    class="text-capitalize"
                  >
                    {{ promotion.status }}
                  </b-badge>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-card
          header="Value Settings"
          header-tag="header"
        >
          <template #header>
            <b-button
              type="button"
              variant="flat-primary"
              class="primary-button-with-background mr-3"
            >
              <feather-icon
                icon="GridIcon"
                class=""
                size="20"
              />
            </b-button>
            <h3 class="align-middle mr-auto">
              Value Settings
            </h3>
          </template>
          <b-table-simple
            borderless
            responsive
            class="custom-th-width"
          >
            <b-tbody>
              <b-tr>
                <b-th width="230">
                  Minimum Purchase Value
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.minPurchaseValue != null ? `$${numberFormat(promotion.minPurchaseValue)}` : 'No limit' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Maximum Purchase Value
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.maxPurchaseValue != null ? `$${numberFormat(promotion.maxPurchaseValue)}` : 'No limit' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Type of Discount
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.discountType || '-' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Discount Value
                </b-th>
                <b-td class="mt-50">
                  {{ discountValueText }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Transaction Code
                </b-th>
                <b-td class="mt-50">
                  {{ transactionCodeText }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Maximum Value
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.maxDiscountValue != null ? `$${numberFormat(promotion.maxDiscountValue)}` : '-' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Required Verification?
                </b-th>
                <b-td class="mt-50">
                  {{ promotion.requiredBdVerification ? 'Yes' : 'No' }}
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTableSimple, BTbody, BTr, BTd, BTh, BBadge,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTableSimple,
    BTbody,
    BTh,
    BTr,
    BTd,
    BBadge,
  },
  data() {
    return {
      promotion: {},
      productOptions: [],
      transactionCodeOptions: [],
    }
  },
  computed: {
    applicableAgentsText() {
      const agents = this.promotion.applicableAgents || []
      if (!agents.length) return '-'
      return agents.map(agent => `${agent.name} (${agent.code})`).join(', ')
    },
    applicableSuitesText() {
      const suites = this.promotion.applicableSuites || []
      if (!suites.length) return 'Usable for all suites'
      return suites.map(suite => suite.name).join(', ')
    },
    applicablePurchaseOptionsText() {
      const options = this.promotion.applicablePurchaseOptions || []
      return options.length ? options.join(', ') : '-'
    },
    applicableProductsText() {
      const products = this.promotion.applicableProducts || []
      if (!products.length) return '-'

      const lotTypes = this.promotion.applicableLotTypes || []
      const lotTypeTitles = lotTypes.map(code => {
        const match = this.productOptions
          .flatMap(product => product.subProducts || [])
          .find(subProduct => subProduct.code === code)
        return match ? match.title : code
      })

      return products.map(name => {
        if (name === 'Niche' && lotTypeTitles.length) {
          return `Niche (${lotTypeTitles.join(', ')})`
        }
        return name
      }).join(', ')
    },
    discountValueText() {
      if (this.promotion.discountType === 'Percentage (%)') {
        return `${this.promotion.discountValue}%`
      }
      if (this.promotion.discountType === 'Singapore Dollars ($)') {
        return `$${this.numberFormat(this.promotion.discountValue)}`
      }
      return '-'
    },
    transactionCodeText() {
      if (!this.promotion.transactionCode) return '-'
      const match = this.transactionCodeOptions.find(item => item.code === this.promotion.transactionCode)
      return match ? match.label : this.promotion.transactionCode
    },
  },
  mounted() {
    this.$http.get(`reservation/promotions/${this.$route.params.id}/show`)
      .then(response => {
        this.promotion = response.data.data

        this.$store.commit('breadcrumb/REMOVE_BREADCRUMB')
        const newMeta = {
          active: true,
          text: this.promotion.name,
        }
        this.$store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })

    this.$http.get('reservation/promotions/respond-with/products')
      .then(response => {
        this.productOptions = response.data.products ?? []
      })
      .catch(() => {})

    this.$http.get('reservation/promotions/respond-with/transaction-codes')
      .then(response => {
        this.transactionCodeOptions = response.data.transactionCodes ?? []
      })
      .catch(() => {})
  },
  setup() {
    const { canViewThisAction } = useAclUtils()

    return {
      canViewThisAction,
    }
  },
  methods: {
    resolveStatusVariant(status) {
      if (status === 'Active') return 'success'
      if (status === 'Inactive') return 'secondary'
      return 'primary'
    },
  },
}
</script>

<style lang="scss">
  .custom-th-width {
    .table th {
        padding: 0.72rem 2rem 0.72rem 0.72rem;
    }
  }
</style>
